/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "handhawk_main";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface RadioType {
}

export enum RadioType_Enum {
  NO_RADIO = 0,
  SKYDIO_LINK = 1,
  MICROHARD_1800 = 2,
  MICROHARD_1624 = 3,
  EXTERNAL_NETWORK = 4,
  UNRECOGNIZED = -1,
}

export function radioType_EnumFromJSON(object: any): RadioType_Enum {
  switch (object) {
    case 0:
    case "NO_RADIO":
      return RadioType_Enum.NO_RADIO;
    case 1:
    case "SKYDIO_LINK":
      return RadioType_Enum.SKYDIO_LINK;
    case 2:
    case "MICROHARD_1800":
      return RadioType_Enum.MICROHARD_1800;
    case 3:
    case "MICROHARD_1624":
      return RadioType_Enum.MICROHARD_1624;
    case 4:
    case "EXTERNAL_NETWORK":
      return RadioType_Enum.EXTERNAL_NETWORK;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RadioType_Enum.UNRECOGNIZED;
  }
}

export function radioType_EnumToJSON(object: RadioType_Enum): string {
  switch (object) {
    case RadioType_Enum.NO_RADIO:
      return "NO_RADIO";
    case RadioType_Enum.SKYDIO_LINK:
      return "SKYDIO_LINK";
    case RadioType_Enum.MICROHARD_1800:
      return "MICROHARD_1800";
    case RadioType_Enum.MICROHARD_1624:
      return "MICROHARD_1624";
    case RadioType_Enum.EXTERNAL_NETWORK:
      return "EXTERNAL_NETWORK";
    case RadioType_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseRadioType(): RadioType {
  return {};
}

export const RadioType = {
  encode(_: RadioType, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RadioType {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRadioType();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RadioType {
    return {};
  },

  toJSON(_: RadioType): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RadioType>, I>>(base?: I): RadioType {
    return RadioType.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RadioType>, I>>(_: I): RadioType {
    const message = createBaseRadioType();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
